import { Box, Button, Container, Grid, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect } from "react";
import api from "../../../utils/api";

import useStressStore from "../../../store/stressStores";
import { useLocation, useNavigate } from "react-router-dom";
import tabbg from "../../../assets/images/tab_01.png"

const StressMain = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // getStressList();

    return () => {
      // storeData.clear();
    }
  }, [])

  function getStressList() {
    let familyId: any = localStorage.getItem('ownerFamID');

    api.get(`customer/api/v2/surveys/stress/families/${encodeURIComponent(familyId)}`)
      .then(res => {
        console.log(res);
        storeData.setStressList(res.data.data);
      })
      .catch(err => {
        console.log(err);
      })
  }

  return (
    <Container className="container">
      <Box sx={img}>
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center' >
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              한국인 직무 스트레스 측정도구(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box className='White_box' sx={{ '& p': { lineHeight: 2, pl: 5 }, width: '80%', ml: 'auto', mr: 'auto' }}>
        <Typography>- KOSS는 산업안전보건연구원에서 근로자의 직무 스트레스 요인을 측정할 수 있도록 개발한 표준화된 도구입니다.</Typography>
        <Typography>- 측정도구는 모두 43개 문항으로 구성됩니다.</Typography>
        <Typography>- 측정하고자 하는 직무 스트레스 요인은 8개 영역으로 물리적 환경, 직무요구, 직무 자율성, 관계 갈등, 직무 불안정, 조직체계, 보상 부적절, 직장문화를 포함합니다.</Typography>
        <Typography>- 각 항목에 대한 느낌이나 생각이 가장 가까운 대답에 표시해 주세요.</Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Button variant="contained" onClick={() => navigate('/stress/answer', { state: location.state })} sx={{ background: '#0d6703', borderRadius: 20, width: '20%', '&:hover': { background: '#074300' } }}>시작하기</Button>
      </Box>
      <Bottom />
    </Container>
  )
}

const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default StressMain;